import { registerWidget } from '../../common/core';
import WidgetDefinition from './dropdown_facet';

registerWidget('dropdown_facet', WidgetDefinition);